import React from 'react'
import type { StyleProp } from '@vtex/admin-ui'
import { csx, cx } from '@vtex/admin-ui'

import { DynamicIcon } from '../DynamicIcon'
import { theme } from '../../../../core/theme/theme'

type AvatarProps = {
  size?: number
  src?: string
  icon?: string | null
  iconBgColor?: string
  className?: string
}

const toRem = (value: number) => `${value}rem`

const containerStyles: StyleProp = {
  display: 'inline-block',
  position: 'relative',
}

// TODO: get size from theme. If it doesn't exist, create our theme
const getImageStyles = (size: AvatarProps['size'] = 3.5): StyleProp => ({
  display: 'block',
  width: toRem(size),
  height: toRem(size),
  borderRadius: '50%',
  pointerEvents: 'none',
  background: '#E0E2E7',
})

const getStatusIconStyles = (bgColor?: string): StyleProp => ({
  position: 'absolute',
  bottom: '-10%',
  right: '-10%',
  width: '2.125rem', // TODO: get size from theme. If it doesn't exist, create our theme
  height: '2.125rem', // TODO: get size from theme. If it doesn't exist, create our theme
  borderRadius: '50%',
  background: bgColor ?? `${theme.bg.NEED_PERFORMANCE_REVIEW_dark.secondary}`,
})

export const Avatar = ({
  size,
  src,
  className = '',
  icon,
  iconBgColor,
  ...props
}: AvatarProps) => (
  <div className={cx(csx({ ...containerStyles }), className)} {...props}>
    <img src={src} alt="" className={csx(getImageStyles(size))} />
    {icon && (
      <div className={csx(getStatusIconStyles(iconBgColor))}>
        <DynamicIcon name={icon} className={csx({ stroke: 'white' })} />
      </div>
    )}
  </div>
)
